import APIHelper from "../common/ApiHelper";
import APIURLConstants from "../common/ApiURLConstants";
import { handleError, authHeader } from "../helper";

export const authService = {
  validateUser,
  logout,
};

async function validateUser(userName, password) {
  let postData = { userName, password };
  return await APIHelper.post(APIURLConstants.POST_VALIDATE_USER, postData)
    .then((result) => {
      return result;
    })
    .catch(handleError);
}

function logout() {
  // remove user from local storage to log user out
  sessionStorage.removeItem("accessToken");
  sessionStorage.removeItem("currentUser");
  //localStorage.clear();

  return APIHelper.get(APIURLConstants.GET_SIGNOUT_URL, authHeader());
}
